var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-slot"},[_c('el-image',{staticClass:"error-photo",attrs:{"src":require('@/assets/pngs/no-image-placeholder.png'),"fit":"scale-down","alt":"picture"}}),_c('br'),_vm._v(" "+_vm._s(_vm.$t("BROKEN_IMG"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }